module.exports = __webpack_public_path__ + "img/confirm-relationship.18233141.png";